<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShare_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6 5a4 4 0 0 0-4 4v7a4 4 0 0 0 4 4h5.1v-7.403l-3.255 1.906c-.255.152-.568.06-.735-.214a.78.78 0 0 1 .062-.89l4.414-5.205a.538.538 0 0 1 .827 0l4.415 5.204a.78.78 0 0 1 .062.89c-.165.272-.477.366-.735.215L12.9 12.597V20H18a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
    />
</svg>
